import LoginService from '@/services/LoginService';
import store from '../store';
import router from '../router';

export interface IUser {
  id: string;
  name: string;
  /** @deprecated Use `roles` array instead. Kept for backward compatibility. */
  role: string;
  roles: string[];
  token: string;
  tokenExpiry: number;
}

export class User implements IUser {
  public roles: string[];

  constructor(
    public id: string,
    public name: string,
    roles: string | string[],
    public token: string,
    public tokenExpiry: number
  ) {
    // Accept either a single role string (backward compat) or an array.
    this.roles = Array.isArray(roles) ? roles : [roles];
  }

  /** Backward-compatible getter: returns the highest-priority role. */
  get role(): string {
    return this.roles[0] ?? '';
  }

  public isAuthenticated() {
    if (this.tokenExpiry < Date.now()) {
      return false;
    }
    return true;
  }

  public refreshToken() {
    if (this.isAuthenticated()) {
      LoginService.refreshToken()
        .then((result: any) => {
          if (
            result &&
            Object.prototype.hasOwnProperty.call(result, 'accessToken') &&
            Object.prototype.hasOwnProperty.call(result, 'expiresIn')
          ) {
            this.token = result.accessToken;
            this.tokenExpiry = Date.now() + result.expiresIn * 1000;
            store.dispatch('login', this);
          }
        })
        .catch((err) => {
          store.dispatch('login', null);
          router.push({ name: 'login' });
        });
    } else {
      store.dispatch('login', null);
      router.push({ name: 'login' });
    }
  }
}
